import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

// Define the base endpoint for field officer
const FIELD_OFFICER_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.FIELD_OFFICER,
  false // No tenant ID in the base URL
);

// Function to get field officer report data
export const getFieldOfficerReportData = async ({ cursor, limit, filter }) => {
  const url = `${FIELD_OFFICER_BASE}/report`;
  const data = await apiClient.post(url, {
    cursor,
    limit,
    filters: filter
  });
  return data;
};

// API functions for field officer
export const fieldOfficerReportApi = {
  // Fetch dynamic form for field officer creation
  getFieldOfficerForm: () =>
    apiClient.get(`${FIELD_OFFICER_BASE}/form?is_edit=false`),

  // Fetch form to edit field officer
  getEditFieldOfficerForm: fieldOfficerId =>
    apiClient.get(
      `${FIELD_OFFICER_BASE}/form?field_officer_id=${fieldOfficerId}&is_edit=true`
    ),

  // Submit a new field officer
  submitFieldOfficer: data => apiClient.post(`${FIELD_OFFICER_BASE}`, data),

  // Submit edited field officer data
  submitEditFieldOfficer: (fieldOfficerId, data) =>
    apiClient.put(`${FIELD_OFFICER_BASE}/${fieldOfficerId}`, data)
};
